import React from 'react';

import { Field } from '@hrlogics/react-components/form';

import { AutocompleteField } from 'src/components/finalForm';
import { useVerifierAutocomplete } from 'src/hooks/verifier';

import { InboxFilterFieldProps, InboxFilterFormFields } from '../types';

export const InboxFilterVerifierField: React.FC<InboxFilterFieldProps> = ({ disabled }) => {
  const verifiersAutocompleteProps = useVerifierAutocomplete();

  return (
    <Field
      fullWidth
      component={AutocompleteField}
      name={InboxFilterFormFields.verifier}
      label="Verifier"
      disabled={disabled}
      multiple
      {...verifiersAutocompleteProps}
    />
  );
};
